import { Guest } from "../pages/Booking";
import { Boutique } from "../types/boutiques"

export interface BookingStep {
  label: string;
  id: string;
  index: number;
}

export interface StepGroup {
  groupLabel: string;
  steps: BookingStep[];
}

export const generateStepGroups = (guestsInfo: Guest[], boutique?: Boutique): StepGroup[] => {
  const stepGroups: StepGroup[] = [
    {
      groupLabel: "Choose Duration",
      steps: [
        { label: "Your Duration", id: "duration-host", index: 1 },
        ...guestsInfo.map((guest, index) => ({
          label: `${guest.firstName || `Guest ${index + 1}`}'s Duration`,
          id: `duration-guest-${index + 1}`,
          index: 2 + index,
        })),
      ],
    },
    {
      groupLabel: "Pressure Preference",
      steps: [
        { label: "Your Pressure", id: "pressure-host", index: 1 },
        ...guestsInfo.map((guest, index) => ({
          label: `${guest.firstName || `Guest ${index + 1}`}'s Pressure`,
          id: `pressure-guest-${index + 1}`,
          index: 2 + index,
        })),
      ],
    },
    {
      groupLabel: "Select Massage",
      steps: [
        { label: "Select Your Massage", id: "massage-host", index: 1 },
        ...guestsInfo.map((guest, index) => ({
          label: `Select ${guest.firstName || `Guest ${index + 1}`}'s Massage`,
          id: `massage-guest-${index + 1}`,
          index: 2 + index,
        })),
      ],
    },
    {
      groupLabel: "Choose Enhancements",
      steps: [
        { label: "Your Enhancements", id: "enhancements-host", index: 1 },
        ...guestsInfo.map((guest, index) => ({
          label: `${guest.firstName || `Guest ${index + 1}`}'s Enhancements`,
          id: `enhancements-guest-${index + 1}`,
          index: 2 + index,
        })),
      ],
    },
  ];

  // If boutique has infrared sauna and there are no guests
  if (boutique?.features?.infraredSauna && !guestsInfo.length) {
    // Put IR step second to last (before enhancements)
    stepGroups.splice(stepGroups.length, 0,
      {
        groupLabel: "Infrared Sauna",
        steps: [
          { label: "Add Infrared Sauna", id: "infrared-host", index: 1 },
        ],
      },
    )
  }

  return stepGroups;
};
